// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ujal","rightAdornment":"Header_rightAdornment__3IKIn"};